const data = {
  products: [
    {
      id:"1",
      name: "Boat Blue Edition",
      category: "Blue",
      image:
        "https://i.pinimg.com/originals/ec/cc/dd/ecccdd6acde405ed59749a4563fccddb.png",
      price: 520,
      countInStock: 5,
    },
    {
      id:"2",
      name: "Boat Black Edition",
      category: "Black",
      image:
        "https://i.pinimg.com/originals/36/9d/79/369d79ae10a5138ce2ce3894617f32f9.jpg",
      price: 440,
      countInStock: 5,
    },
    {
      id:"3",
      name: "JBL White Edition",
      category: "White",
      image:
        "https://i.pinimg.com/originals/c0/ac/e9/c0ace9e4b0bdfb9e086b3601b888e775.jpg",
      price: 500,
      countInStock: 5,
    },
    {
      id:"4",
      name: "Cat Purple Edition",
      category: "Purple",
      image:
        "https://i.pinimg.com/originals/a9/f2/ac/a9f2acd97694373832d3bbd6e6fdf389.jpg",
      price: 7 - 0,
      countInStock: 5,
    },
    {
      id:"5",
      name: "JBL White Edition",
      category: "White",
      image:
        "https://i.pinimg.com/originals/94/c9/70/94c970776a4c26bf36796a7756557533.jpg",
      price: 600,
      countInStock: 5,
    },
    {
      id:"6",
      name: "JBL Green Edition",
      category: "Green",
      image:
        "https://i.pinimg.com/originals/ba/1d/5d/ba1d5dc7887daef0407516b7a120efea.jpg",
      price: 600,
      countInStock: 5,
    },
    {
      id:"7",
      name: "JBL Green Edition",
      category: "Green",
      image:
        "https://i.pinimg.com/originals/cc/65/73/cc6573f4e22c630de4daea30baace900.jpg",
      price: 500,
      countInStock: 5,
    },
    {
      id:"8",
      name: "JBL Black Edition",
      category: "Black",
      image:
        "https://i.pinimg.com/originals/b6/7a/62/b67a629877f700218b40412f4cdd1c2d.jpg",
      price: 540,
      countInStock: 5,
    },
    {
      id:"9",
      name: "JBL Green Edition",
      category: "Green",
      image:
        "https://i.pinimg.com/236x/7a/cd/8c/7acd8c93e59575feef413a62f2db42dc--skullcandy-headphones-dre-headphones.jpg",
      price: 550,
      countInStock: 5,
    },
    {
      id:"10",
      name: "Morshall Green Edition",
      category: "Green",
      image:
        "https://i.pinimg.com/originals/93/87/5a/93875a5807c088019066bc3823cc4c23.jpg",
      price: 550,
      countInStock: 5,
    },
  ],
};

export default data;
